<div class="bg">
  <iframe #versionFrame id="versionFrame" [srcdoc]="safeVersionHtml" (load)="iframeLoaded()"></iframe>
</div>
